module.exports = require("./src/content/ContentParser")
